
        import * as module0 from 'controllers/accordion_controller.js';import * as module1 from 'controllers/carousel_controller.js';import * as module2 from 'controllers/compound_interest_controller.js';import * as module3 from 'controllers/currency_input_controller.js';import * as module4 from 'controllers/dialog_controller.js';import * as module5 from 'controllers/popup_controller.js';import * as module6 from 'controllers/scroll_animation_controller.js';import * as module7 from 'controllers/text_randomizer_controller.js';import * as module8 from 'controllers/ticker_controller.js'
        const modules = {
            "controllers/accordion_controller.js": module0,
            "controllers/carousel_controller.js": module1,
            "controllers/compound_interest_controller.js": module2,
            "controllers/currency_input_controller.js": module3,
            "controllers/dialog_controller.js": module4,
            "controllers/popup_controller.js": module5,
            "controllers/scroll_animation_controller.js": module6,
            "controllers/text_randomizer_controller.js": module7,
            "controllers/ticker_controller.js": module8,
        };
        export default modules;
      